// return true if the domain is the production domain or subdomains mysherpas.ai
export const isProductionDomain = (): boolean => {
    if (typeof window === 'undefined') {
        return false;

    }
    const domain = window.location.hostname;
    return domain.includes('mysherpas.ai');
};